import { RootState } from '../../main/store/main.store.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { mapAttemptsHistory } from '../mappers/attempts-history.mapper.ts';

export const selectAttemptsHistory = createMemoizedSelector(
  (state: RootState) => state.activityTracking.attempts,
  (attempts) => mapAttemptsHistory(attempts)
);
